import { Link, Outlet } from 'react-router-dom';

import { useEnumApi } from 'contexts/EnumApiContext';
import MenuInfo from 'data/menu';
import { ROLE } from 'data/data';

export default function MonitoringSettingLayout() {
    const setting = MenuInfo.CMMS_MANAGEMENT;
    const { role } = useEnumApi();
    return (
        <>
            <div className="mrosetup_sub">
                <ul>
                    {
                        setting.children.map(child => {
                            if ((role === ROLE.SA.code) || (role === ROLE.WA.code && child.id === 18100)) {
                                return (
                    <li key={child.id}>
                        <Link to={child.fullpath}>
                            {
                                child.isActive
                                ? (<b>{child.name}</b>) 
                                : child.name
                            }
                        </Link>
                    </li>
                                );
                            }
                        })
                    }
                </ul>
            </div>

            <div className="main_container">
                <Outlet/>
            </div>
        </>
    );
}